module.exports = __webpack_public_path__ + "img/93.f9c684a7.jpg";